export class ClassRadioButtonSource {
    public DisplayExpr: string = "";
    public ValueExpr: any = "";
    constructor(DisplayExpr: string,ValueExpr: any  ){
        this.DisplayExpr = DisplayExpr;
        this.ValueExpr = ValueExpr;
    }
  }
  